import { render } from "./WNWhitelist.vue?vue&type=template&id=8194197a&scoped=true"
import script from "./WNWhitelist.vue?vue&type=script&lang=js"
export * from "./WNWhitelist.vue?vue&type=script&lang=js"

import "./WNWhitelist.vue?vue&type=style&index=0&id=8194197a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8194197a"

export default script